import { BsBuildingCheck, BsFileSpreadsheet, BsFillPinMapFill, BsListColumnsReverse, BsTable } from "react-icons/bs";
import { FaCameraRetro, FaFileInvoiceDollar } from "react-icons/fa6";
import { GiChart, GiSouthAmerica } from "react-icons/gi";
import { HiOutlineFire, HiOutlineUser, HiOutlineUsers, HiOutlineIdentification } from "react-icons/hi2";
import { IoBusiness } from "react-icons/io5";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { LuClipboardList } from "react-icons/lu";
import { MdOutlineCategory } from "react-icons/md";
import { PiListPlusLight, PiSuitcaseSimpleThin } from "react-icons/pi";
import { SiAffinitydesigner, SiOutline } from "react-icons/si";
import {
  TbUserDollar,
  TbCalendarCog,
  TbReportSearch,
  TbBuildingCircus,
  TbBuildingCommunity,
  TbUserScreen,
  TbTargetArrow,
} from "react-icons/tb";
import { TfiMoney } from "react-icons/tfi";
import { ROLES } from "./roles";

const icon = (Icon) => <Icon className="icon" />;

export const UTILITARIAS_BASE = [
  { path: "/inventario", icon: icon(IoBusiness), text: "Inventario" },
  { path: "/mediakit", icon: icon(SiAffinitydesigner), text: "Mediakit" },
  { path: "/portafolio", icon: icon(PiSuitcaseSimpleThin), text: "Portafolio" },
  { path: "/mapa", icon: icon(BsFillPinMapFill), text: "Mapa" },
  { path: "/listadoempresas", icon: icon(BsListColumnsReverse), text: "Empresas por edificio" },
  { path: "/categorias", icon: icon(MdOutlineCategory), text: "Análisis Categorías" },
  { path: "/simulador-impacto", icon: icon(TbTargetArrow), text: "Simulador Impacto" },
  { path: "/galeria", icon: icon(FaCameraRetro), text: "Galería" },
];

export const IPSOS_CHILE = { path: "/investigacion-ipsos", icon: icon(TbReportSearch), text: "Respaldo IPSOS" };

// Ítem de Perfil
const PERFIL_ITEM = { path: "/admin/perfil", icon: icon(HiOutlineUser), text: "Mi Perfil" };

// Ítem de Proyección Comercial
const PROYECCION_ITEM = { path: "/admin/ventas-proyeccion", icon: icon(GiChart), text: "Proyección Comercial" };

// Ítem ER
const ER_ITEM = { path: "/admin/er", icon: icon(BsTable), text: "ER" };

// Helper: renombra "Mediakit" → "Mediakit Publicitario" y agrega "Mediakit Edificios" (link externo)
const withMediakitEdificios = (items, pais) => {
  const renamed = items.map((item) => (item.text === "Mediakit" ? { ...item, text: "Mediakit Publicitario" } : item));
  const mediakitEdificios = {
    path: pais === "Chile" ? "https://wecast.cl/edificios" : "https://visiona.pe/edificios",
    icon: icon(TbBuildingCommunity),
    text: "Mediakit Edificios",
    external: true,
  };
  const idx = renamed.findIndex((item) => item.text === "Mediakit Publicitario");
  if (idx !== -1) renamed.splice(idx + 1, 0, mediakitEdificios);
  else renamed.push(mediakitEdificios);
  return renamed;
};

const GESTION_EMPLEADOS_ITEM = {
  path: "/admin/gestion-empleados",
  icon: icon(HiOutlineIdentification),
  text: "Gestión Empleados",
};

export const MENU_CONFIG = {
  // ==================== BOARD ====================
  [ROLES.BOARD]: {
    utilitarias: ({ pais }) =>
      withMediakitEdificios(
        UTILITARIAS_BASE.filter((h) => !["Análisis Categorías", "Respaldo IPSOS"].includes(h.text)),
        pais
      ),
    ventas: ({ allowedRegionIds, id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM" },
      ...([1, 4].includes(id) ? [{ path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" }] : []),
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id }) => {
      const base = [
        { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Gestión Usuarios" },
      ];
      if (id === 1 || id === 4) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      return base;
    },
    financieras: () => [ER_ITEM, { path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" }],
  },
  // ==================== COMERCIAL ====================
  [ROLES.COMERCIAL]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, IPSOS_CHILE], pais),
    ventas: ({ allowedRegionIds, id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM & Ventas" },
      ...([1, 4].includes(id) ? [{ path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" }] : []),
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      { path: "/admin/ventas-btl", icon: icon(TbBuildingCircus), text: "Below The Line" },
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id }) => {
      const base = [
        { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(FaFileInvoiceDollar), text: "Comisión Comercial" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Gestión Usuarios" },
        PERFIL_ITEM,
      ];
      return base;
    },
    financieras: () => [],
  },
  // ==================== GERENCIA ====================
  [ROLES.GERENCIA]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, IPSOS_CHILE], pais),
    ventas: ({ allowedRegionIds, id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM" },
      ...([1, 4].includes(id) ? [{ path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" }] : []),
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      { path: "/admin/ventas-btl", icon: icon(TbBuildingCircus), text: "Below The Line" },
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id }) => {
      const base = [
        { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Gestión Usuarios" },
        { path: "/admin/cargar-intermediario", icon: icon(LuClipboardList), text: "Cargar Agencia" },
        GESTION_EMPLEADOS_ITEM,
        PERFIL_ITEM,
      ];
      if (id === 1 || id === 4) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      return base;
    },
    financieras: () => [ER_ITEM, { path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" }],
  },
  // ==================== SUPERADMIN ====================
  [ROLES.SUPERADMIN]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: ({ allowedRegionIds, id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM & Ventas" },
      ...([1, 4].includes(id) ? [{ path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" }] : []),
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id, pais }) => {
      const base = [
        { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(FaFileInvoiceDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
        { path: "/admin/cargar-intermediario", icon: icon(LuClipboardList), text: "Cargar Agencia" },
        ...(pais === "Perú"
          ? [{ path: "/admin/cargar-oportunidad", icon: icon(LuClipboardList), text: "Cargar Oportunidad" }]
          : []),
        PERFIL_ITEM,
      ];
      if (id === 1 || id === 4) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      return base;
    },
    financieras: () => [ER_ITEM],
  },
  // ==================== ADMINISTRATIVO ====================
  [ROLES.ADMINISTRATIVO]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: ({ allowedRegionIds, id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id, pais }) => {
      const base = [
        { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        ...(pais === "Chile"
          ? [{ path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" }]
          : []),
        { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
        GESTION_EMPLEADOS_ITEM,
      ];
      if (id === 1 || id === 4) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      return base;
    },
    financieras: () => [ER_ITEM, { path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" }],
  },
  // ==================== OTROS ROLES ====================
  [ROLES.EDIFICIO]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, IPSOS_CHILE], pais),
    ventas: () => [],
    administrativas: () => [],
    financieras: () => [{ path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" }],
  },
  [ROLES.CONTABLE]: {
    utilitarias: () => [],
    ventas: () => [PROYECCION_ITEM],
    administrativas: () => [
      { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
      { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
      { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
    ],
    financieras: () => [ER_ITEM, { path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" }],
  },
  [ROLES.INVERSOR]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, IPSOS_CHILE], pais),
    ventas: () => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM" },
      PROYECCION_ITEM,
    ],
    administrativas: () => [
      { path: "/admin/ventas-facturas", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
      { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
      { path: "/admin/informes-comision", icon: icon(LuClipboardList), text: "Comisión Edificios" },
      { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Gestión Clientes" },
      { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Gestión Usuarios" },
    ],
    financieras: () => [ER_ITEM],
  },
  [ROLES.AGENCIA]: {
    // utilitarias eliminada intencionalmente → usará el fallback base
    ventas: () => [{ path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" }],
    administrativas: () => [],
    financieras: () => [],
  },
  [ROLES.CLIENTE]: {
    // utilitarias eliminada intencionalmente → usará el fallback base
    ventas: () => [{ path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" }],
    administrativas: () => [],
    financieras: () => [],
  },
  // ==================== INFRAESTRUCTURA ====================
  [ROLES.INFRAESTRUCTURA]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: () => [],
    administrativas: () => [
      { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
      { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Gestión Usuarios" },
    ],
    financieras: () => [],
  },
};
